import { abortableFetch, Filter } from '@eas/common-web';
import { EvidenceAPI, IncludeOptions } from '../../enums';
import { LatLng } from 'leaflet';

import { CrzpCoordinates } from '../../models';

/* Test data */
// import irzJson from './test-data/irz.json';
// import ovzJson from './test-data/ovz.json';
// import prodJson from './test-data/prod-sites.json';

type CoordinatesResponse = {
  items: CrzpCoordinates[];
};

/* Return test data */
// function importCoordinatesFromJson(api: EvidenceAPI): CoordinatesResponse {
//   switch (api) {
//     case EvidenceAPI.IRZ_FACILITIES:
//       return irzJson as CoordinatesResponse;
//     case EvidenceAPI.OVZ_FACILITIES:
//       return ovzJson as CoordinatesResponse;
//     case EvidenceAPI.PRODUCTION_SITES:
//       return prodJson as CoordinatesResponse;
//     default:
//       return { items: [] };
//   }
// }

export async function getCoordinates(
  leftCorner: LatLng,
  rightCorner: LatLng,
  filters: Filter[],
  api: EvidenceAPI
) {
  const fetch = abortableFetch(`${api}/coordinates`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({
      include: [IncludeOptions.DEACTIVATED],
      filters: [
        {
          operation: 'GEO_BOUNDING_BOX',
          field: 'wgs84Point',
          topLeft: {
            lat: leftCorner.lat,
            lon: leftCorner.lng,
          },
          bottomRight: {
            lat: rightCorner.lat,
            lon: rightCorner.lng,
          },
        },
        ...filters,
      ],
    }),
  });

  /* Return test data */

  // if ([true][0]) {
  //   const { items = [] } = importCoordinatesFromJson(api);
  //   /* simulate delay */
  //   await new Promise((resolve) => setTimeout(resolve, 5000));
  //   return items;
  // }

  const { items = [] } = (await fetch.json()) as CoordinatesResponse;

  return items;
}
